import React, { useEffect } from 'react';
import { FieldArray, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import FormikDirectImageUpload from '../../components/formik/FormikDirectImageUpload';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { authAxiosInstance } from '../../utils/axiosConfig';
import { toast } from 'react-toastify';
import { X } from 'react-feather';
import DangerButton from '../../components/infrastructure/Buttons/DangerButton';
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic';

const EditQuotationTemplateModal = ({ showEditModal, setShowEditModal, editData, onSuccess }) => {

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: editData?.name || "",
            firm: editData?.firm || "",
            headerImg: editData?.headerImg || "",
            footerImg: editData?.footerImg || "",
            termsImg: editData?.termsImg || [],
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Name is required"),
            firm: Yup.string().required("Firm name is required"),
            headerImg: Yup.string().required("Header Img is required"),
            footerImg: Yup.string().required("Footer Img is required")
        }),
        onSubmit: async (values, { resetForm }) => {
            try {
                const updatedValues = {
                    ...values,
                    termsImg: values?.termsImg?.filter(
                        (item) => item !== ""
                    ),
                };
                console.log("updatedValues", updatedValues);
                await authAxiosInstance.patch(`/quotationTemplate`, { ...updatedValues, _id: editData._id });
                toast.success('Template edited successfully');
                resetForm();
                setShowEditModal(false);
                onSuccess();
            } catch (error) {
                toast.error('Failed to update template');
            }
        }
    });

    return (
        <ModalBasic
            modalOpen={showEditModal}
            setModalOpen={setShowEditModal}
            title="Edit Quotation Template"
            max_width="max-w-2xl"
        >
            <div className="p-4 overflow-y-auto ">
                {/* Modal Form */}
                <form onSubmit={formik.handleSubmit} className="flex flex-col gap-4">
                    <FormikInputGroup
                        name="name"
                        label="Name"
                        formik={formik}
                        required
                    />
                    <FormikInputGroup
                        name="firm"
                        label="Firm Name"
                        formik={formik}
                        required
                    />
                    <div className='flex items-center gap-2'>
                        <FormikDirectImageUpload
                            label="Header Image"
                            name="headerImg"
                            location="iml_group/quotation_templates/"
                            randomize
                            required
                            formik={formik}
                        />
                        <span className="text-sm text-gray-600">
                            Size (2540px × 436px)
                        </span>
                    </div>
                    <div className="flex items-center gap-2">
                        <FormikDirectImageUpload
                            label="Footer Image "
                            name="footerImg"
                            location="iml_group/quotation_templates/"
                            randomize
                            required
                            formik={formik}
                        />
                        <span className="text-sm text-gray-600">
                            Size (2540px × 238px)
                        </span>
                    </div>
                    <FormikProvider value={formik}>
                        <FieldArray
                            name="termsImg"
                            render={(arrayHelpers) => {
                                return (
                                    <div className="flex flex-col gap-3">
                                        {formik.values.termsImg?.map((ele, i) => (
                                            <div
                                                key={i}
                                                className="flex items-center gap-2"
                                            >
                                                <FormikDirectImageUpload
                                                    label={`Terms Image ${i + 1}`}
                                                    formik={formik}
                                                    name={`termsImg.${i}`}
                                                    randomize
                                                    location={'iml_group/quotation_templates/'}
                                                />

                                                <DangerButton
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.stopPropagation();

                                                        arrayHelpers.remove(i);
                                                    }}
                                                >
                                                    Remove
                                                </DangerButton>
                                            </div>
                                        ))}

                                        <div className="flex items-center gap-2">
                                            <PrimaryButton
                                                className={"px-2 py-1"}
                                                type="button"
                                                onClick={() => {
                                                    arrayHelpers.push('');
                                                }}
                                            >
                                                Add Terms Image
                                            </PrimaryButton>
                                            <span className="text-sm text-gray-600">
                                                Size (1200px × 1700px)
                                            </span>
                                        </div>
                                    </div>
                                );
                            }}
                        />
                    </FormikProvider>
                    <div className="flex gap-3 mt-2">
                        <PrimaryButton
                            type="submit"
                            disabled={formik.isSubmitting}
                        >
                            Update
                        </PrimaryButton>
                        <button
                            type="button"
                            onClick={() => setShowEditModal(false)}
                            className="px-4 py-2 border rounded"
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>

        </ModalBasic >
    );
};

export default EditQuotationTemplateModal;